var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"LocationName","options":_vm.schools,"value":_vm.selectedSchool,"placeholder":"Select a School"},model:{value:(_vm.selectedSchool),callback:function ($$v) {_vm.selectedSchool=$$v},expression:"selectedSchool"}})}
var staticRenderFns = []

export { render, staticRenderFns }